export default function resolveRewrites() {}
